// cdn链接地址
export const CONFIG_CDN_URL = 'http://m1.2048.net/duoniu/';